export default __webpack_public_path__ + "static/media/orange-glow.ea26f792.png";